// import BrowserDetect from './BrowserDetect';
import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import {TimelineMax,TweenMax} from 'gsap';
import inview from 'jquery-inview';
// import Swiper from 'swiper';
import Swiper from 'swiper/dist/js/swiper.min.js';
import 'es6-promise/auto';
import axios from 'axios';

/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
	// console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
//通常盤
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec();

//execに可変引数で処理を渡してナビの開閉時に処理させるサンプル
//例として、SPナビでアコーディオンを開くたびにiScrollをリセットする
// let spnav_accordion_1 = (scroller)=>{
	// $('#scroller .inner > ul > li > span').off();
	// $('#scroller .inner > ul > li > span').on('click',function(){

		// let $parent = $(this).parent('li');
		// let $child = $(this).next('.gnavi-child');
		// let status = $child.css('display');

		// if(status == 'block'){
		// 	$child.slideUp(300,function(){
		// 		scroller.refresh();
		// 	});
		// 	$parent.removeClass('active');
		// }else{
		// 	$child.slideDown(300,function(){
		// 		scroller.refresh();
		// 	});
		// 	$parent.addClass('active');
		// }

		// return false;
	// });
// }
let gNavAppend = ()=>{
	$(".btn_sp_navi").on("click", function () {
		let gNav = $(".js-gNav");
		if (!$("#scroller .c-gNav").length) {
			// console.log("nav");
			gNav.clone().appendTo("#scroller");
		}
	});
}
gNavAppend();

/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop','#global_footer',100,400);
totop.exec();

/* ===============================================
#	const
=============================================== */
const w = $(window);
const rFlg = $('#responsive_flg');
/* ===============================================
#	wrap
=============================================== */
w.on("load resize",function(){
	// let contWidth = window.innerWidth - 20;
	let contHeight = window.innerHeight - 20;
	// console.log({ contWidth, contHeight});

	$(".l-wrap").css({height: contHeight});
})
/* ===============================================
#	totop
=============================================== */
const totopRotate = () =>{
	$(".l-wrap").on('scroll',function(){
		let scrollY = $(this).scrollTop();
		$(".c-totop").css({transform:"rotate(" + scrollY*0.3 +"deg)"});
	});
};
totopRotate();

/* ===============================================
#	bg move
=============================================== */
const bgMove = ()=>{
	$(".l-wrap").on("scroll",function(){
		let scrollY = $(this).scrollTop();
		// console.log(scrollY);
		// $(this).css({backgroundPositionY: scrollY * (-0.01) +"px," + scrollY * (-0.015) +"px," + scrollY * (-0.02) +"px"});
		// $(this).css({backgroundPositionX: scrollY * (-0.01) +"px," + scrollY * (-0.02) +"px," + scrollY * (-0.03) +"px"});
	});
}
bgMove();

/* ===============================================
#	fadeInWindowFlame
=============================================== */
const fadeInWindowFlame =()=>{

}
/* ===============================================
#	gnav
=============================================== */
const gNavChildShow =()=>{
	$('.js-gNav-has-child').hover(
		function(){
			if (rFlg.css('display')!='none'){
				if($(".spnavi").css("display") == "block"){return false;}
				let target = $(this).find('.c-gNav_child');
				const tl = new TimelineMax();
				tl.to(target,1,{opacity:1,scaleX:1,scaleY:1,ease:Elastic.easeOut.config(1, 0.5)},0);
			}
		},
		function(){
			if (rFlg.css('display') != 'none') {
				if ($(".spnavi").css("display") == "block"){return false;}
				let target = $(this).find('.c-gNav_child');
				const tl = new TimelineMax();
				tl.to(target,0.2,{opacity:0,scaleX:0.2,scaleY:0},0.2);
			}
		}
	)
};
gNavChildShow();


/* ===============================================
#	inview
=============================================== */

const finishInview = (elm)=>{
	setTimeout(function(){
			$(elm).addClass("-is-inviewed");
		},
	500);
}
const rotateBox = (elm)=>{
	TweenMax.fromTo(
		elm,
		0.6,
		{ opacity: 0, rotation: -20 },
		{ opacity: 1, rotation: 0, ease: Back.easeOut.config(1.7), onComplete: finishInview(elm) },
	);
};
const fadein = (elm)=>{
	TweenMax.fromTo(
		elm,
		1,
		{ opacity: 0, },
		{ opacity: 1, onComplete: finishInview(elm) },
	);
}
const thumbRotateInvew =()=>{
	$(".js-inview-rotateBox").one("inview", function () {
		console.log("rotate");
		rotateBox(this);
	})
	$(".js-inview-fadein").one("inview", function () {
		console.log("fadein");
		fadein(this);
	})
};

thumbRotateInvew();

/* ===============================================
#	mw wp form
=============================================== */
$(".mwform-tel-field input").attr({placeholder:"0000"});

/* ===============================================
#	swiper
=============================================== */
const slideRelated = new Swiper('.js-slideRelated', {
	centeredSlides: true,
	slidesPerView: "auto",
	slidesPerGroup: 1,
	loop: true,
	spaceBetween: 40,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		// when window width is >= 320px
		768: {
			centeredSlides: false,
			slidesPerView: 2,
			spaceBetween: 10
		},
		960: {
			spaceBetween: 20
		},
	}
});

//product
const slideProductMain = new Swiper('.js-slideProductMain', {
	effect: 'fade',
	// slidesPerView: 1,
	// slidesPerGroup: 1,
	// loop: true,
	// spaceBetween: 40,

	thumbs:{
		swiper:{
			el:".js-slideProductThumb",
			// slidesPerGroup: 1,
			centeredSlides: true,
			// centerInsufficientSlides: true,
			slidesPerView: 5,

			loop: true,
			spaceBetween: 10,

			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				768: {
					centeredSlides: false,
					slidesPerView: 4,
					spaceBetween: 6
				},
			}
		}
	}
});

/* ===============================================
#	news read more
=============================================== */
const loadmore = (url, button) => {
	axios({
		method: 'GET',
		url: url,
		responseType: 'document',
	})
	.then((res) => {
		button.remove();
		const item = res.data.querySelectorAll('.js-more-target');
		const nextButton = res.data.querySelectorAll('.js-btn-more');

		$(item).appendTo(".js-more-target-list");
		$(nextButton).appendTo(".c-btn_wrap");

		//フェードイン処理
		thumbRotateInvew();
	})
	.catch(() => {
		console.error('dataCatchFailed!!');
	});
};

$('.c-btn_wrap').on('click', ".js-btn-more", function () {
	const button = $(this);
	const req = button.attr('data-link');
	loadmore(req, button);
});

/* ===============================================
#	 wysiwyg
=============================================== */
$(".p-wysiwyg h2,.p-wysiwyg h3").wrapInner('<span class="line"></span>');

/* ===============================================
#	 totop
=============================================== */
$(".js-totop").on("click",function(){
	TweenMax.to(".l-wrap", 0.5, { scrollTop:0});
})

/* ===============================================
#	 global nav home only
=============================================== */
const gHeaderHome = $(".js-globalHeaderHome"),
	l_wrap = $(".l-wrap");
l_wrap.on("scroll",function(){
	let scrl = l_wrap.scrollTop(),
		threshold = $(".p-homeMv").height();
	if (scrl > threshold){
		gHeaderHome.addClass("is-active");
	}else{
		gHeaderHome.removeClass("is-active");
	}
})


/* ===============================================
#	 新規登録フォーム
#    個人情報の取り扱いに同意するまではsubitをdisableに
=============================================== */
const checkAgreement = ()=>{
	const newMemberPage = $("#newmember");
	const newMemberSubmit = $(".js-new-member-submit input[type='submit']");
	const agreement = $(".js-agreement");
	if (newMemberPage<1 || newMemberSubmit.length < 1) {
		return;
	}

	const toggleState = () => {
		if (agreement.prop("checked")) {
			newMemberSubmit.prop("disabled", false);
		} else {
			newMemberSubmit.prop("disabled", true);
		}
	};


	//初回読み込み時
	if(agreement.length){
		toggleState();
	}

	// クリック時
	agreement.on('click',function(){
		toggleState();
	})

}
checkAgreement();